export enum WebhookEndpointEventsTableActionType {
  ChangeSortingType = 'webhookEndpointEventsTable/changeSortingType',
  ResetState = 'webhookEndpointEventsTable/resetState',
}
